import React from "react";
import { usePageTitle } from "../utils/usePageTitle";

function Notfound({ title }) {
  usePageTitle(title);
  return <div className="antialiased">Oeps! You hit a 404! Go back</div>;
}

export default Notfound;
